import { DECIMAL } from './DECIMAL.js';
import { INTEGER } from './INTEGER.js';
export const INTEGER_DECIMAL = `${INTEGER} or ${DECIMAL}`;
//# sourceMappingURL=INTEGER_DECIMAL.js.map